module.exports = __webpack_public_path__ + "static/media/Logo_DT_White.cc3ffc06.png";